import faq from '~/api/common/faq'
import siteConfig from '~/api/common/siteConfig'
import getTaxonomy from '~/api/common/taxonomy'
import property from '~/api/property/property'
import subdomain from '~/api/subdomain/index'
import stats from '~/api/home/stats'
import demo from '~/api/common/demo'
import home from '~/api/home/home'
import map from '~/api/map'
import media from '~/api/media/index'

export default axios => ({
  siteConfig: siteConfig(axios),
  faq: faq(axios),
  getTaxonomy: getTaxonomy(axios),
  property: property(axios),
  subdomain: subdomain(axios),
  stats: stats(axios),
   demo: demo(axios),
   home: home(axios),
   map: map(axios),
    media: media(axios),

})
